import script from "./InvestorAcknowledgement.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestorAcknowledgement.vue?vue&type=script&setup=true&lang=js"

import "./InvestorAcknowledgement.vue?vue&type=style&index=0&id=5581dc11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5581dc11"]])

export default __exports__